import PropTypes from 'prop-types'
import React from 'react'
import { DeleteBtn } from '../DeleteBtn'
import { RotateRightBtn } from '../RotateRightBtn'
import { RotateLeftBtn } from '../RotateLeftBtn'

export const Preview = ({photos, dropSource, handleDragStart, handleDragEnd, rotateLeft, rotateRight, remove, isPlusAvailable}) =>
  <div className='dropzone-previews fotografije-group'>
    {
      photos.map((item, index) => {
        const url = `url(${item.url})`
        const cursor = `move`
        const hoverClass = `${dropSource != null ? `disable-hover` : ``}`
        return (
          <div
            className={`ad-image item`}
            key={item.id || item.tmpId}
            draggable='true'
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            data-id={item.id}
            data-index={index}
          >
            <div className={`img-container ${hoverClass}`}>
              <div className='img'>
                <div style={{backgroundImage: url, cursor}} data-dragarea='true' data-change={index} />
              </div>
            </div>
            <div className='img-actions'>
              <div />
              <div />
              <RotateLeftBtn onClick={rotateLeft} index={index} item={item} />
              <DeleteBtn onClick={remove} index={index} item={item} />
              <RotateRightBtn onClick={rotateRight} index={index} item={item} />
              <div />
              <div />
            </div>
          </div>
        )
      })
    }
    {
      photos.length && isPlusAvailable
        ? <div className='dz-message addBtn'>
          <div className='addBtn__wrapper'>
            <a href='javascript:void(0)' className='addBtn__plus'> + </a>
          </div>
        </div>
        : null
    }
  </div>

Preview.propTypes = {
  dropSource: PropTypes.any,
  handleDragEnd: PropTypes.func.isRequired,
  handleDragStart: PropTypes.func.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    tmpId: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired,
  remove: PropTypes.func.isRequired,
  rotateLeft: PropTypes.func.isRequired,
  rotateRight: PropTypes.func.isRequired,
  isPlusAvailable: PropTypes.bool.isRequired
}

Preview.defaultProps = {
  photos: [],
  isPlusAvailable: false
}
